import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IndicadorService } from '../indicador.service';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { Indicador } from '../../comum/modelos/indicador';
import { ConfirmationService } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-listar-indicadores',
  templateUrl: './listar-indicadores.component.html',
  styleUrls: ['./listar-indicadores.component.css']
})
export class ListarIndicadoresComponent implements OnInit {

  filtroPesquisaNomeIndicador: string;
  indicadores: Indicador[];
  statusCode: number;
  public paginacao: Paginacao;
  public evento: Evento;

  public loading = false;

  constructor(
    private _indicadorAcessoService: IndicadorService,
    private _comumService: ComumService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private _cookieService: CookieService,
    private _authService: AuthService) {
    this.indicadores = new Array<Indicador>();
    this.paginacao = new Paginacao();
    this.evento = this._comumService.evento;
    this.loading = false;
    if (this.evento !== undefined) {
      setTimeout(() => {
        this._comumService.cleanEvent();
      }, 2000);
    }
  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.loading = true;
    this._indicadorAcessoService.obterIndicadoresClienteHttp(parseInt(this._cookieService.get('idCliente')))
      .subscribe((indicadores) => {
        this.indicadores = indicadores;
        this.loading = false;
      });
  }

  removerIndicador(indicador: Indicador): void {
    const self = this;
    this.confirmationService.confirm({
      message: 'Deseja excluir este indicador operacional?',
      accept: () => {
        this._indicadorAcessoService.removerIndicadorHttp(indicador.idIndicador)
          .subscribe(response => {
            this.loading = false;
            this.statusCode = response.status;
            this._comumService.evento.deletar = true;
            this.removerIndicadorFromList(this.indicadores, indicador);
            this.router.navigate(['listar-indicadores']);
            setTimeout(() => {
              self.evento.limparEventos();
            }, 3000);
          }, errorCode => {
            this._comumService.evento.deletar = true;
            this._comumService.evento.error = true;
            this.statusCode = errorCode;
            this.loading = false;
            setTimeout(() => {
              self.evento.limparEventos();
            }, 3000);
          });
      }, reject: () => {
      }
    });
  }

  removerIndicadorFromList(indicadores: Indicador[], indicador: Indicador): void {
    const index = this.obterIdIndicador(indicadores, indicador);
    indicadores.splice(index, 1);
  }

  obterIdIndicador(indicadores: Indicador[], indicador: Indicador): number {
    return indicadores.indexOf(indicador);
  }
  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaNomeIndicador = filtro.value;
  }

  limparPesquisaPorFiltro(filtro: any): void {
    filtro.value = '';
    this.pesquisarPorFiltro(filtro);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/indicador/listar-indicadores/listar-indicadores.component.ts